import { ImpactLensProfilePlain } from '@upright/ui/common/upright/core/impact-lens-profile/main';

export const ImpactLensProfile = ImpactLensProfilePlain;
